import { useState } from "react";
import Cart from "./components/Cart";
import Navbar from "./components/Navbar";
import ProductWrapper from "./components/ProductWrapper";

function App() {
  const [isProductPage, setisProductPage] = useState(true);

  return (
    <>
      {/* Navbar */}
      <Navbar setisProductPage={setisProductPage} />
      {/* Navbar ends */}
      <main className="py-16">
        {/* <ProductWrapper /> */}
        {isProductPage ? <ProductWrapper /> : <Cart />}
      </main>
    </>
  );
}

export default App;
